module.exports = __webpack_public_path__ + "img/086db2d4d423e2436a7f356db3acc5e5.png";